module.exports = __webpack_public_path__ + "img/Compact-FR_Overview-EVA_1.4558bcc8.jpg";